export default __webpack_public_path__ + "static/en_ln-936b3e06a248ded823dd6b5d722f688f.gif";